<template>
    <!--底部按钮-->
    <div class="hy-fixed-userBtn">
      <span class="iconfont fixed-link" @click="openFooterNav()">&#xe60c;</span>
      <div class="hy_footer_nav" :class="footerNav? 'active':''">
        <template v-if="id != ''">
          <a class="nav-link2 blue" v-if="jumpPage == 1" :href="'/index/Conference/template?id='+id+'&qrCode='+qrCode"><span class="text">会议首页</span></a>
          <router-link class="nav-link2 blue" v-else-if="jumpPage == 2" :to="'/info/'+id"><span class="text">会议首页</span></router-link>
          <router-link class="nav-link2 blue" v-else-if="jumpPage == 3" :to="'/shares/1?id='+id"><span class="text">会议首页</span></router-link>

          <a class="nav-link2 iconfont" :href="item.url" v-for="item in list">
            <span class="text">{{item.title}}</span>
          </a>
       </template>

        <router-link class="nav-link2 iconfont" to="/myEnroll">
          <span class="text">我的</span>
        </router-link>
      </div>
    </div>
</template>
<script>
  export default {
    components: {},
    props:{
      id:{
        type:[String,Number],
        default:'',
      },
      jumpPage:{
        type:[String,Number],
        default:2,
      }
    },
    data() {
      return {
        footerNav:false,
        list:null,
        qrCode:'',
      };
    },
    mounted() {
      if(this.id != ''){
        this.initpage();
      } 
      if(localStorage.getItem("qrCode") != "undefined"){
        this.qrCode = localStorage.getItem("qrCode");
      }
    },
    methods: {
       initpage(){
         var _this = this;
         let url = "/ac1/conference/column/indexcolumn";
         let params = {
           conference_id: _this.id,
         };
         _this.$get(url, params).then(res => {
           if (res.code == "1") {
             _this.list = res.posts;
           }else{
             _this.$toast(res.msg);
           }
         },function(res){
           console.log(res.msg);
         });
       },
      //打开底部链接
      openFooterNav(val) {
        //   this.$toast(val);
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
    }
  };
</script>
